import { useId, useState } from 'react';

const RETIREMENT_RULE = 'بازنشستگی این مورد را از مجموعهٔ کاری و همهٔ انتشارهای آینده کنار می‌گذارد؛ نسخه‌های منتشرشده تغییر نمی‌کنند و نقشهٔ زنده فقط با انتشار بعدی تغییر می‌کند.';

export default function RetirementAction({ busy = false, itemLabel, onConfirm }) {
  const generatedId = useId().replace(/:/g, '');
  const reasonId = `cov-retirement-reason-${generatedId}`;
  const ruleId = `cov-retirement-rule-${generatedId}`;
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  const confirm = async () => {
    const trimmedReason = reason.trim();
    if (!trimmedReason || busy) return;
    const succeeded = await onConfirm(trimmedReason);
    if (succeeded) {
      setReason('');
      setOpen(false);
    }
  };

  if (!open) {
    return (
      <button type="button" className="cov-text-btn cov-retire-trigger" onClick={() => setOpen(true)}>
        بازنشسته کردن
      </button>
    );
  }

  return (
    <div className="cov-retirement-confirm" role="group" aria-label={`تأیید بازنشستگی ${itemLabel}`}>
      <p id={ruleId}>{RETIREMENT_RULE}</p>
      <label htmlFor={reasonId}>
        <span>دلیل ثبت در حسابرسی</span>
        <input
          id={reasonId}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          disabled={busy}
          aria-describedby={ruleId}
          placeholder="مثلاً ثبت آزمایشی یا جایگزینی با مرجع اصلاح‌شده"
        />
      </label>
      <div className="cov-retirement-buttons">
        <button type="button" className="cov-btn cov-btn-danger" disabled={!reason.trim() || busy} onClick={confirm}>
          بازنشسته کردن
        </button>
        <button type="button" className="cov-btn cov-btn-secondary" disabled={busy} onClick={() => { setOpen(false); setReason(''); }}>
          انصراف
        </button>
      </div>
    </div>
  );
}
